// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3KASK","actionsCol":"EnrolledClinics_actionsCol__2FbnY"};